export const PASSWORD_REQUIREMENTS = {
    MIN_LENGTH: 'MinLength',
    MAX_LENGTH: 'MaxLength',
    MIN_UPPERCASE: 'MinUppercase',
    MIN_LOWERCASE: 'MinLowercase',
    MIN_DIGIT: 'MinDigit',
    MIN_SPECIALCHARACTER: 'MinSpecialCharacter',
    LIMIT_CONSECUTIVE_CHARACTERS: 'LimitConsecutiveCharacters',
    REQUIRE_LETTERS: 'RequireLetters',
    PASSWORD_TIMEOUT_IN_DAYS: 'PasswordTimeoutInDays',
};
